module.exports = __webpack_public_path__ + "static/img/logo_rewards_light_bg.2a12a29.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo_rewards_light_bg.svg
// module id = xRqq
// module chunks = 3